mutation CreateTrivia(
  $eventId: ID!
  $name: String
  $broadcasterUserIds: [String!]!
  $question: String!
  $options: [StreamToolsTriviaOptionInput!]!
  $youtubeVotesEnabled: Boolean
  $hideLiveResults: Boolean
  $showAnswersCounter: Boolean
  $closeGraceSeconds: Int
  $callToActionText: String
  $headingTextColor: String!
  $optionsTextColor: String!
  $callToActionTextColor: String!
  $headingBackground: String!
  $optionsBackground: String!
  $callToActionBackground: String!
  $alternatingOptionBackground: String
  $backgroundImage: String
  $backgroundImageFit: StreamToolsImageFit
  $cornerRadius: Int!
  $borderWidth: Int
  $borderColor: String
  $winnerOutlineColor: String
  $fontKey: String
  $questionFontSize: Int
  $displayTextFontSize: Int
  $commandFontSize: Int
  $numberFontSize: Int
  $callToActionFontSize: Int
  $revealTextFontSize: Int
) {
  trivia: StreamToolsCreateTrivia(
    eventId: $eventId
    name: $name
    broadcasterUserIds: $broadcasterUserIds
    question: $question
    options: $options
    youtubeVotesEnabled: $youtubeVotesEnabled
    hideLiveResults: $hideLiveResults
    showAnswersCounter: $showAnswersCounter
    closeGraceSeconds: $closeGraceSeconds
    callToActionText: $callToActionText
    headingTextColor: $headingTextColor
    optionsTextColor: $optionsTextColor
    callToActionTextColor: $callToActionTextColor
    headingBackground: $headingBackground
    optionsBackground: $optionsBackground
    callToActionBackground: $callToActionBackground
    alternatingOptionBackground: $alternatingOptionBackground
    backgroundImage: $backgroundImage
    backgroundImageFit: $backgroundImageFit
    cornerRadius: $cornerRadius
    borderWidth: $borderWidth
    borderColor: $borderColor
    winnerOutlineColor: $winnerOutlineColor
    fontKey: $fontKey
    questionFontSize: $questionFontSize
    displayTextFontSize: $displayTextFontSize
    commandFontSize: $commandFontSize
    numberFontSize: $numberFontSize
    callToActionFontSize: $callToActionFontSize
    revealTextFontSize: $revealTextFontSize
  ) {
    triviaId
    eventId
    name
    broadcasterUserIds
    question
    status
    dedupe
    youtubeVotesEnabled
    totalVotes
    hasYouTubeVotes
    hideLiveResults
    showAnswersCounter
    closeGraceSeconds
    closedAt
    graceEndsAt
    revealedAt
    youtubeCountsPurgedAt
    youtubeFinalAt
    youtubeCountingUntil
    answersIn { twitch youtube }
    startedAt
    stoppedAt
    createdAt
    callToActionText
    headingTextColor
    optionsTextColor
    callToActionTextColor
    headingBackground
    optionsBackground
    callToActionBackground
    alternatingOptionBackground
    backgroundImage
    backgroundImageFit
    cornerRadius
    borderWidth
    borderColor
    winnerOutlineColor
    fontKey
    questionFontSize
    displayTextFontSize
    commandFontSize
    numberFontSize
    callToActionFontSize
    revealTextFontSize
    version
    options {
      optionId
      displayText
      command
      voteCount
      voteCountByPlatform { twitch youtube }
      textColor
      progressBarColor
      isCorrect
      backgroundColor
    }
  }
}
